// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InstitutionScholars_institution-scholars__8wd8c .InstitutionScholars_scholar__Lajsg {
  display: flex;
  align-items: flex-start;
  margin-bottom: 25px;
}
.InstitutionScholars_institution-scholars__8wd8c .InstitutionScholars_scholar__Lajsg .InstitutionScholars_avatar__nlNhY {
  width: 60px;
  height: 60px;
  position: relative;
  margin-right: 20px;
}
.InstitutionScholars_institution-scholars__8wd8c .InstitutionScholars_scholar__Lajsg .InstitutionScholars_avatar__nlNhY .InstitutionScholars_photo__dH-mn {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}
.InstitutionScholars_institution-scholars__8wd8c .InstitutionScholars_scholar__Lajsg .InstitutionScholars_avatar__nlNhY .InstitutionScholars_check__-VlT3 {
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
  right: -5px;
}
.InstitutionScholars_institution-scholars__8wd8c .InstitutionScholars_scholar__Lajsg .InstitutionScholars_info__9sIdm p {
  margin-bottom: 3px !important;
}
.InstitutionScholars_institution-scholars__8wd8c .InstitutionScholars_scholar__Lajsg .InstitutionScholars_info__9sIdm .InstitutionScholars_name__j4dcK {
  font-weight: bold;
  cursor: pointer;
}
.InstitutionScholars_institution-scholars__8wd8c .InstitutionScholars_scholar__Lajsg .InstitutionScholars_info__9sIdm .InstitutionScholars_name__j4dcK:hover {
  text-decoration: underline;
  color: var(--blue);
}
.InstitutionScholars_institution-scholars__8wd8c .InstitutionScholars_scholar__Lajsg .InstitutionScholars_info__9sIdm .InstitutionScholars_inst-name__AeUMi {
  color: var(--dark-grey);
  font-weight: 600;
}
.InstitutionScholars_institution-scholars__8wd8c .InstitutionScholars_scholar__Lajsg .InstitutionScholars_info__9sIdm .InstitutionScholars_position__lCldr {
  color: var(--dark-grey);
  font-style: italic;
}
.InstitutionScholars_institution-scholars__8wd8c .InstitutionScholars_scholar__Lajsg .InstitutionScholars_info__9sIdm .InstitutionScholars_tags__yPrSJ {
  margin-bottom: 5px;
}
.InstitutionScholars_institution-scholars__8wd8c .InstitutionScholars_search-scholar-section__bbnDU {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 10px;
}
.InstitutionScholars_institution-scholars__8wd8c .InstitutionScholars_search-container__1NK8q {
  max-width: 350px;
  display: flex;
  align-items: center;
}
.InstitutionScholars_institution-scholars__8wd8c .InstitutionScholars_search-container__1NK8q .ant-select {
  width: 100%;
}
.InstitutionScholars_institution-scholars__8wd8c .InstitutionScholars_search-container__1NK8q .InstitutionScholars_clear-search-button__MZoBT {
  height: 32px;
  padding: 4px 8px;
  border: 1px solid var(--explore-color);
  color: var(--dark-grey);
  background: transparent;
  margin-left: 10px;
}
.InstitutionScholars_institution-scholars__8wd8c .InstitutionScholars_search-container__1NK8q .InstitutionScholars_clear-search-button__MZoBT:hover {
  background: var(--explore-color);
  color: white;
  cursor: pointer;
}
.InstitutionScholars_institution-scholars__8wd8c .InstitutionScholars_search-container__1NK8q .InstitutionScholars_clear-search-button__MZoBT:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionDetail/Components/InstitutionScholars/InstitutionScholars.module.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAAN;AAEM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAAR;AAGM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AADR;AAMM;EACE,6BAAA;AAJR;AAOM;EACE,iBAAA;EACA,eAAA;AALR;AAQM;EACE,0BAAA;EACA,kBAAA;AANR;AASM;EACE,uBAAA;EACA,gBAAA;AAPR;AAUM;EACE,uBAAA;EACA,kBAAA;AARR;AAWM;EACE,kBAAA;AATR;AAcE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AAZJ;AAcE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAZJ;AAcI;EACE,WAAA;AAZN;AAeI;EACE,YAAA;EACA,gBAAA;EACA,sCAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;AAbN;AAeM;EACE,gCAAA;EACA,YAAA;EACA,eAAA;AAbR;AAgBM;EACE,YAAA;EACA,mBAAA;AAdR","sourcesContent":[".institution-scholars {\n  .scholar {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 25px;\n\n    .avatar {\n      width: 60px;\n      height: 60px;\n      position: relative;\n      margin-right: 20px;\n\n      .photo {\n        width: 60px;\n        height: 60px;\n        border-radius: 50%;\n        object-fit: cover;\n      }\n\n      .check {\n        position: absolute;\n        width: 20px;\n        height: 20px;\n        bottom: 0;\n        right: -5px;\n      }\n    }\n\n    .info {\n      p {\n        margin-bottom: 3px !important;\n      }\n\n      .name {\n        font-weight: bold;\n        cursor: pointer;\n      }\n\n      .name:hover {\n        text-decoration: underline;\n        color: var(--blue);\n      }\n\n      .inst-name {\n        color: var(--dark-grey);\n        font-weight: 600;\n      }\n\n      .position {\n        color: var(--dark-grey);\n        font-style: italic;\n      }\n\n      .tags {\n        margin-bottom: 5px;\n      }\n    }\n  }\n\n  .search-scholar-section {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 10px;\n  }\n  .search-container {\n    max-width: 350px;\n    display: flex;\n    align-items: center;\n\n    :global(.ant-select) {\n      width: 100%;\n    }\n\n    .clear-search-button {\n      height: 32px;\n      padding: 4px 8px;\n      border: 1px solid var(--explore-color);\n      color: var(--dark-grey);\n      background: transparent;\n      margin-left: 10px;\n\n      &:hover {\n        background: var(--explore-color);\n        color: white;\n        cursor: pointer;\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"institution-scholars": `InstitutionScholars_institution-scholars__8wd8c`,
	"scholar": `InstitutionScholars_scholar__Lajsg`,
	"avatar": `InstitutionScholars_avatar__nlNhY`,
	"photo": `InstitutionScholars_photo__dH-mn`,
	"check": `InstitutionScholars_check__-VlT3`,
	"info": `InstitutionScholars_info__9sIdm`,
	"name": `InstitutionScholars_name__j4dcK`,
	"inst-name": `InstitutionScholars_inst-name__AeUMi`,
	"position": `InstitutionScholars_position__lCldr`,
	"tags": `InstitutionScholars_tags__yPrSJ`,
	"search-scholar-section": `InstitutionScholars_search-scholar-section__bbnDU`,
	"search-container": `InstitutionScholars_search-container__1NK8q`,
	"clear-search-button": `InstitutionScholars_clear-search-button__MZoBT`
};
export default ___CSS_LOADER_EXPORT___;
